<modal-component>

	<!-- LEFT-->
	<div class="_context" left>
		<div class="_header">
			<ng-container *ifUserHasPermissions="[UserPermissions.WriteConfigurations]">
				<p *ngIf="action === 'create'" class="_title" [translate]="'LOCATION.CREATE'"></p>
				<p *ngIf="action === 'update'" class="_title" [translate]="'LOCATION.EDIT'"></p>
			</ng-container>
			<ng-container *ifUserHasNotPermissions="[UserPermissions.WriteConfigurations]">
				<p class="_title" [translate]="'LOCATION.READ'"></p>
			</ng-container>
			<p class="_subtitle">{{locationForm?.get('place').value}}</p>
		</div>

		<!-- info or context -->
		<div class="_map-container" #mapContainer>
			<map-component 
				*ngIf="mapIsReady && locationForm.get('Address.lat').value && locationForm.get('Address.long').value" 
				[height]="mapContainer.clientHeight" 
				[lat]="locationForm.get('Address.lat').value" 
				[long]="locationForm.get('Address.long').value"
			></map-component>
		</div>

	</div>
	
	<!-- RIGHT -->
	<ng-container right>

		<form [formGroup]="locationForm" [disable-form-if-not-permission]="[UserPermissions.WriteConfigurations]"> 

			<p class="_title" [translate]="'LOCATION.ADDRESS'"></p>
			<form-full-address [formGroup]="locationForm.get('Address') | cast"></form-full-address>

			<p class="_title" [translate]="'LOCATION.EXTRA'"></p>
			<form-input label="{{ 'LOCATION.PLACE' | translate }}" [formControl]="locationForm.get('place') | cast"></form-input>
			<form-textarea label="{{ 'LOCATION.COMMENT' | translate }}" [formControl]="locationForm.get('comment') | cast"></form-textarea>

		</form>
	</ng-container>
	

	<!-- BUTTONS -->
	<ng-container buttons *ifUserHasPermissions="[UserPermissions.WriteConfigurations]">
		<button (click)="delete()" class="_button _delete-button" *ngIf="action === 'update'" [translate]="'LOCATION.DELETE'">
		</button>
		<button (click)="createOrUpdate()" class="_button _add-button" [translate]="action === 'create' ? 'LOCATION.CREATE' : 'LOCATION.UPDATE'"></button>
		<button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="close()"></button>
	</ng-container>
</modal-component>